import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { formatValue, isEmptyValue } from './helpers';
import {
  OldValue, NewValue, EmptyValue, ClearedValue
} from './MachineCsv.styled';

// One side of a change: the value now, or the value after the import.
function ChangeValue({ field, value, after }) {
  const { t } = useTranslation();
  if (isEmptyValue(value)) {
    return after
      ? <ClearedValue>{t('assets.csv.preview.cleared', { defaultValue: '(cleared)' })}</ClearedValue>
      : <EmptyValue>{t('assets.csv.preview.empty', { defaultValue: '(empty)' })}</EmptyValue>;
  }
  const text = formatValue(t, field, value);
  return after ? <NewValue>{text}</NewValue> : <OldValue>{text}</OldValue>;
}

ChangeValue.propTypes = {
  field: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  after: PropTypes.bool
};

ChangeValue.defaultProps = {
  value: null,
  after: false
};

export default ChangeValue;
